import { render, staticRenderFns } from "./uploaddownexcelbyrole.vue?vue&type=template&id=a935a200"
import script from "./uploaddownexcelbyrole.vue?vue&type=script&lang=js"
export * from "./uploaddownexcelbyrole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports